import { FC, useMemo } from "react";
import { SxProps } from "@mui/material";
import { Box, useTheme } from "@mui/material";

export const ResizeHandleBar: FC = () => {
  const theme = useTheme();
  const sx: SxProps = useMemo(
    () => ({
      width: "30px",
      height: "3px",
      backgroundColor: theme.palette.grey[400],
      borderRadius: "1.5px",
    }),
    [theme.palette.grey]
  );

  return <Box sx={sx} />;
};
